import { observer } from 'mobx-react-lite'
import { useEffect, useState } from "react";

type Props = {
  length?: number;
  onChange?: (code: string) => void;
};

export const VerifyCode = ({ length = 6, value, onChange }: any) => {
  const [code, setCode] = useState('')

  useEffect(() => {
    console.log(value)
    setCode(value)
  }, [value])

  const changeCode = (e: any) => {
    const onlyDigits = e.replace(/\D/g, "");
    onChange(onlyDigits.slice(0, length))
  }

  return (
    <div
      onClick={() => document.getElementById("hidden-input")?.focus()}
      style={{
        display: "flex",
        justifyContent: "center", // центр по горизонтали
        alignItems: "center",     // центр по вертикали
        width: "100%",
      }}
    >
      <div
        onClick={() => document.getElementById("hidden-input")?.focus()}
        style={{
          display: "flex",
          gap: "8px", // ← расстояние между цифрами
          cursor: "text",
        }}
      >
        {/* Скрытый инпут */}
        <input
          id="hidden-input"
          type="text"
          inputMode="numeric"
          value={code}
          onChange={(e) => changeCode(e.target.value)}
          style={{
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
          }}
        />

        {/* Отрисовка ячеек */}
        {Array.from({ length }).map((_, i) => (
          <div
            key={i}
            style={{
              width: "40px",
              height: "50px",
              border: "2px solid #ccc",
              borderRadius: "8px",
              fontSize: "24px",
              textAlign: "center",
              lineHeight: "50px",
            }}
          >
            {code[i] || ""}
          </div>
        ))}
      </div>
    </div>
  );
}